import { useState } from 'react';
import { toast } from 'react-toastify';
import fleetApi from '../../services/api.service';

const usePatchStepETA = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(null);
  const [data, setData] = useState(null);

  const updateStepETA = async (stepId, estimatedTime) => {
    resetStates();
    try {
      setIsLoading(true);
      const response = await fleetApi.patch(
        `/tours-planning/steps/${stepId}/estimated-delivery`,
        { estimated_delivery: estimatedTime }
      );

      if (response.status === 200) {
        setIsSuccess(true);
        setData(response.data);
        console.log(`✅ ETA mis à jour pour l'étape ${stepId}: ${estimatedTime}`);
        return response.data;
      } else {
        throw new Error(response.data?.message || 'Une erreur est survenue.');
      }
    } catch (error) {
      setIsSuccess(false);
      console.error(`❌ Erreur lors de la mise à jour de l'ETA pour l'étape ${stepId}:`, error);
      toast.error(
        error?.response?.data?.message ||
          error?.message ||
          'Erreur lors de la mise à jour de l\'ETA'
      );
      throw error;
    } finally {
      setIsLoading(false);
    }
  };

  const resetStates = () => {
    setIsSuccess(false);
    setIsLoading(false);
    setData(null);
  };

  return {
    isLoading,
    isSuccess,
    data,
    updateStepETA,
  };
};

export default usePatchStepETA;

